module.exports = __webpack_public_path__ + "static/media/super-hit.8846da93.png";